import {
  useFormState,
  useFormValidation,
} from '../../../../hocs/useFormWithValidation';

import { PROFILE_FIELDS_TYPES } from '../../../../constants/formFields';

export const initialEmergencyContactState = {
  [PROFILE_FIELDS_TYPES.EMAIL]: '',
  [PROFILE_FIELDS_TYPES.RELATION]: '',
  [PROFILE_FIELDS_TYPES.LAST_NAME]: '',
  [PROFILE_FIELDS_TYPES.FIRST_NAME]: '',
  [PROFILE_FIELDS_TYPES.PHONE_NUMBER]: '',
};

export function useEmergencyContactFormState(state, errors) {
  const { formState, handleFormChange } = useFormState({
    ...initialEmergencyContactState,
    ...state,
  });
  const {
    clearErrors,
    validateErrors,
    addLocalValidateErrors,
  } = useFormValidation(errors);

  const onMobilePhoneChange = (phone, formatMessage) => {
    clearErrors();
    if (phone.length && phone.length < 10) {
      addLocalValidateErrors(
        PROFILE_FIELDS_TYPES.PHONE_NUMBER,
        formatMessage({ id: 'errors.validation.invalidLoginPhone' }),
      );
    }
    handleFormChange({
      ...formState,
      [PROFILE_FIELDS_TYPES.PHONE_NUMBER]: phone,
    });
  };

  const onEmailChange = email => {
    clearErrors();
    handleFormChange({ ...formState, [PROFILE_FIELDS_TYPES.EMAIL]: email });
  };

  return {
    formState,
    clearErrors,
    onEmailChange,
    validateErrors,
    handleFormChange,
    onMobilePhoneChange,
    addLocalValidateErrors,
  };
}



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/EmergencyContact/utils/useEmergencyContactFormState.js